import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Breadcrumb from './Breadcrumb';
import styles from './MainLayout.module.css';

// Single source of truth for both the topbar title and the breadcrumb trail,
// so the two never drift out of sync.
const pageConfig = {
  '/': { title: 'Home', breadcrumb: ['Home'] },
  '/appraisal': { title: 'Appraisal Form', breadcrumb: ['Home', 'Appraisal Form'] },
  '/appraisal-report': { title: 'Appraisal Report', breadcrumb: ['Home', 'Appraisal Report'] },
  '/employees': { title: 'Employees', breadcrumb: ['Home', 'Employees'] },
  '/code-of-conduct': {
    title: 'Code of Conduct Acknowledgement',
    breadcrumb: ['Home', 'Code of Conduct Acknowledgement'],
  },
  '/rnr': { title: 'Rewards & Recognition', breadcrumb: ['Home', 'Rewards & Recognition'] },
  '/lsa': { title: 'Long Service Awards', breadcrumb: ['Home', 'Long Service Awards'] },
  '/hrms': { title: 'HRMS', breadcrumb: ['Home', 'HRMS'] },
  '/birthdays': { title: 'Birthdays', breadcrumb: ['Home', 'Birthdays'] },
};
const defaultPageConfig = { title: 'HR Portal', breadcrumb: ['Home'] };

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const config = location.pathname.startsWith('/appraisal/')
    ? pageConfig['/appraisal']
    : pageConfig[location.pathname] || defaultPageConfig;

  const breadcrumbItems = config.breadcrumb.map((label) => ({
    label,
    path: label === 'Home' ? '/' : undefined,
  }));

  return (
    <div className={styles.wrapper}>
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed(!collapsed)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <div className={`${styles.content} ${collapsed ? styles.collapsed : ''}`}>
        <Topbar
          collapsed={collapsed}
          pageTitle={config.title}
          onMobileMenuOpen={() => setMobileOpen(true)}
        />
        <div className={styles.page}>
          <Breadcrumb items={breadcrumbItems} />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;